"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearAllIcon = void 0;
const react_1 = __importDefault(require("react"));
const ClearAllIcon = () => (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { d: "M16 1.468L14.532 0L8 6.532L1.468 0L0 1.468L6.532 8L0 14.532L1.468 16L8 9.468L14.532 16L16 14.532L9.468 8L16 1.468Z", fill: "#D44142" })));
exports.ClearAllIcon = ClearAllIcon;
//# sourceMappingURL=ClearAllIcon.js.map